import { render, staticRenderFns } from "./tipo_procedimentos.vue?vue&type=template&id=ef04d270"
import script from "./tipo_procedimentos.vue?vue&type=script&lang=js"
export * from "./tipo_procedimentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports